import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as messageInfo from '../message-info'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: messageInfo.RESOURCE.payload.dimension.partialId,
      partialId: messageInfo.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'The entry itself, one item of the message\u2019s info list',
    isOptional: false,
    name: 'Entry',
    partialId: PartialId.Standard.create('entry'),
    type: core.common.value.types.Intrinsic.Object,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
